import {
    requireAnyOrgPermission,
    requireAnySystemPermission,
    SystemPermissionType,
} from '@juvare/contact-management/backend/features/permissions/shared';
import { UserState } from '@juvare/platform-sdk-react/types';

/**
 * @deprecated and should be replaced with {@link requireManageAccountsAndAnySystemPermission}`
 * TODO: should be replaced and deleted with `requireManageAccountsAndAnySystemPermission` with CRMS-4451
 */
export function requireManageMembersAndAnySystemPermission(userState?: UserState, ...permissions: SystemPermissionType[]) {
    const hasPermission = requireAnySystemPermission(userState, ...permissions);

    if (!hasPermission) {
        return false;
    }

    return requireAnySystemPermission(userState, 'manage-accounts') || requireAnyOrgPermission(userState, 'manage-members');
}
